import React from 'react';
import IntlMessages from "../helpers/IntlMessages";

const RestartConversation = ({ isOpen, close_confirmed, close_cancel, mobile }) => {
    if (!isOpen) return null;
    return (
        <div className="chat_popup_restartchat">
            <div className={`chat_popup_restartchat_text ${mobile === "true" ? "restartchat_text-mobile" : ""}`}>
                <div className={`restartchat-ask ${mobile === "true" ? "restartchat-ask-mobile" : ""}`}>
                    <p><strong>Restart your chat conversation</strong></p>
                    <span>Are you sure you want to end the current chat?</span>
                </div>
                <div className={`restart-buttons ${mobile === "true" ? "restart-btn-mobile" : ""}`}>
                    <button
                        className="restartChat-button"
                        onClick={(e) => close_confirmed()}
                    >
                        <span>Restart Chat</span>
                    </button>
                    <button className="restart-cancelchat_button" onClick={() => close_cancel(false)}>
                        <IntlMessages id="check.availabity.cancel" />
                    </button></div>
            </div>
        </div>
    );
};

export default RestartConversation;
